import React from "react";
import { Box } from "@mui/system";
import { Card, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AssessmentIcon from "@mui/icons-material/Assessment";

const HomePage = () => {
  const navigate = useNavigate();
  const NAV_ITEMS = [
    {
      text: "Configuration",
      to: "/app/wizard",
      icon: <SettingsIcon sx={{ fontSize: 48 }} />,
    },
    {
      text: "Batch Upload",
      to: "/app/batch",
      icon: <UploadFileIcon sx={{ fontSize: 48 }} />,
    },
    {
      text: "Upload Governance",
      to: "/app/upload-governance",
      icon: <AssessmentIcon sx={{ fontSize: 48 }} />,
    },
  ];

  return (
    <Box
      className="home-page animate__animated animate__fadeIn animate__delay-05s"
      sx={{ m: 2, gap: 4, display: "flex", flexDirection: "column" }}
    >
      <h1
        style={{
          textAlign: "center",
        }}
      >
        Welcome to the Prospect HUB
      </h1>
      <Box
        sx={{
          padding: {
            xs: "0px 20px", // extra-small screens
            sm: "0px 50px", // small screens
            md: "0px 100px", // medium screens
            lg: "0px 250px", // large screens
          },
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 25,
            justifyContent: "center",
          }}
        >
          {NAV_ITEMS.map((item) => (
            <Card
              onClick={() => navigate(item.to)}
              sx={{
                flex: 1,
                cursor: "pointer",
                height: 200,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                "&:hover": {
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                },
                borderRadius: 15,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: 2,
                }}
              >
                {item.icon}
                <Typography
                  variant="subtitle1"
                  sx={{
                    mt: 2,
                    textAlign: "center",
                    // fontSize: 16,
                  }}
                >
                  {item.text}
                </Typography>
              </Box>
            </Card>
          ))}
        </div>
      </Box>
    </Box>
  );
};

export default HomePage;
